export const GET_ALL_FLOORPLAN_PRICING =
  'app/VIEW_UNIT/EDIT_FEES/GET_ALL_FLOORPLAN_PRICING';
export const GET_ALL_FLOORPLAN_PRICING_FAILURE =
  'app/VIEW_UNIT/EDIT_FEES/GET_ALL_FLOORPLAN_PRICING_FAILURE';
export const GET_ALL_FLOORPLAN_PRICING_SUCCESS =
  'app/VIEW_UNIT/EDIT_FEES/GET_ALL_FLOORPLAN_PRICING_SUCCESS';
export const CREATE_FLOORPLAN_PRICING =
  'app/VIEW_UNIT/EDIT_FEES/CREATE_FLOORPLAN_PRICING';
export const CREATE_FLOORPLAN_PRICING_FAILURE =
  'app/VIEW_UNIT/EDIT_FEES/CREATE_FLOORPLAN_PRICING_FAILURE';
export const CREATE_FLOORPLAN_PRICING_SUCCESS =
  'app/VIEW_UNIT/EDIT_FEES/CREATE_FLOORPLAN_PRICING_SUCCESS';
export const UPDATE_FLOORPLAN_PRICING =
  'app/VIEW_UNIT/EDIT_FEES/UPDATE_FLOORPLAN_PRICING';
export const UPDATE_FLOORPLAN_PRICING_FAILURE =
  'app/VIEW_UNIT/EDIT_FEES/UPDATE_FLOORPLAN_PRICING_FAILURE';
export const UPDATE_FLOORPLAN_PRICING_SUCCESS =
  'app/VIEW_UNIT/EDIT_FEES/UPDATE_FLOORPLAN_PRICING_SUCCESS';
export const DELETE_FLOORPLAN_PRICING =
  'app/VIEW_UNIT/EDIT_FEES/DELETE_FLOORPLAN_PRICING';
export const DELETE_FLOORPLAN_PRICING_FAILURE =
  'app/VIEW_UNIT/EDIT_FEES/DELETE_FLOORPLAN_PRICING_FAILURE';
export const DELETE_FLOORPLAN_PRICING_SUCCESS =
  'app/VIEW_UNIT/EDIT_FEES/DELETE_FLOORPLAN_PRICING_SUCCESS';

export const FEE_MODES = {
  MARKET_RENT: 'MARKET_RENT',
  QUOTING_RENT: 'QUOTING_RENT',
  DEPOSIT: 'DEPOSIT',
  GROSS_RENT: 'GROSS_RENT',
  FINANCIAL_MARKET_RENT: 'FINANCIAL_MARKET_RENT',
  UTILITY_ALLOWANCE: 'UTILITY_ALLOWANCE',
  RD_UTILITY_ALLOWANCE: 'RD_UTILITY_ALLOWANCE',
  HUD_GROSS_RENT: 'HUD_GROSS_RENT',
  NOTE_RENT: 'NOTE_RENT',
  BASIC_RENT: 'BASIC_RENT',
  NON_OPTIONAL_CHARGE: 'NON_OPTIONAL_CHARGE',
  '236_BASIC_RENT': '236_BASIC_RENT',
  '236_MARKET_RENT': '236_MARKET_RENT',
  // Unfortunately the form needs a key for each program, so as we add more programs
  // to the Gross Rent by Program feature; we will need to add more keys here.
  HOME_GROSS_RENT: 'HOME_GROSS_RENT',
  HTF_GROSS_RENT: 'HTF_GROSS_RENT',
  PH_MAXIMUM_RENT: 'PH_MAXIMUM_RENT',
  PH_FLAT_RENT: 'PH_FLAT_RENT',
};

export const FORM_MODES = {
  ADD: 'ADD',
  EDIT: 'EDIT',
};
